var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 23,
    viewBox: "0 0 88 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.5746C4.23498 14.5954 6.52125 10.7219 9.26829 7.08764C10.1411 5.9329 13.4472 0.507301 15.9512 2.39531C18.8093 4.55032 20.589 10.1626 22.4553 13.0582C26.4527 19.2601 31.433 23.6921 38.5528 19.1128C43.0576 16.2155 45.2959 11.8744 48.4065 7.70992C50.803 4.50153 52.3066 5.64888 55.5772 7.10446C61.2042 9.60875 66.655 11.66 72.8293 12.2173C75.7254 12.4786 79.2889 12.3082 82.1951 11.6791C86.922 10.6557 82.5617 11.2836 86 10.0981",
    stroke: "#4162FD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign);
export default __webpack_public_path__ + "static/media/sign.4a47b9a44e25e7df2ecb881dbed2a77d.svg";
export { ForwardRef as ReactComponent };